function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.currentVariantId = this.querySelector('.currentVariantId');
    const curminusElem = this.querySelector('button[name="minus"]');
    this.changeEvent = new Event('change', { bubbles: true });
    const curqtyVal = parseInt(this.input.value);
    curqtyVal > 1 ? (curminusElem.disabled = false) : (curminusElem.disabled = true);
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  getAllVariantInventory(event) {
    const variantInventoryList = Array.from(this.querySelectorAll('.variantInventory')).map(
      (varEl) => {
        const varElData = {
          id: varEl.dataset.varid,
          quantity: varEl.dataset.quant,
        };
        return varElData;
      }
    );
    return variantInventoryList;
  }
  getVariantDataValues() {
    return JSON.parse(document.querySelector('[type="application/json"]').textContent);
  }

  onButtonClick(event) {
    event.preventDefault();
    const variantInvetoryElements = this.getAllVariantInventory();
    const currentVariantID = this.currentVariantId.dataset.vid;
    const vid = this.getVariantDataValues();
    let quantLimit = null;
    variantInvetoryElements.forEach((vIEl) => {
      if (vIEl.id === currentVariantID) {
        quantLimit = vIEl.quantity;
      }
    });
    const previousValue = this.input.value;
    const ariaElem = this.querySelector('[data-aria-live]');
    const isplus = event.target.name === 'plus';
    const isMinus = event.target.name === 'minus';
    isplus ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    const newVal = parseInt(this.input.value);
    if (newVal >= quantLimit) {
      this.querySelector('.quantity__button[name="plus"]').classList.add('disableQuantitySelector');
      this.querySelector('.quantity__button[name="plus"]').setAttribute('aria-disabled', 'true');
    } else {
      this.querySelector('.quantity__button[name="plus"]').classList.remove(
        'disableQuantitySelector'
      );
      this.querySelector('.quantity__button[name="plus"]').setAttribute('aria-disabled', 'false');
    }
    const minusElem = !isplus ? event.target : this.querySelector('button[name="minus"]');
    if (minusElem) {
      if (newVal < 2) {
        minusElem.disabled = true;
        minusElem.setAttribute('aria-disabled', 'true');
      } else {
        minusElem.disabled = false;
        minusElem.setAttribute('aria-disabled', 'false');
      }
    }

    if (!ariaElem) return;
    const msg =
      isMinus && previousValue == 1
        ? 'Disabled button,Minimum quantity is 1'
        : isMinus
          ? 'item decreased by 1'
          : 'item increased by 1';

    ariaElem.textContent = '';
    setTimeout(function () {
      ariaElem.textContent = msg;
    }, 250);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (const key in params) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.statusElem = document.querySelector('#pdp-variant-status');
    this.addEventListener('change', this.onVariantChange);
    this.ProductContainer = this.closest('.product');
  }

  onVariantChange() {
    _theme.toggleLoading(1);
    this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
    this.updateOptions();
    this.updateMasterId();
    this.updateProductQuantity();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateOptionLabel();
    this.toggleQuantityButtonState();
    this.dispatchEvent(new CustomEvent('variant:changed'));

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if (!this.isQuickview) this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateKlarnaWidget();
      if (window._ltk && this.currentVariant.sku) {
        window._ltk.Activity.AddProductBrowse(this.currentVariant.sku);
      }

      // Update variant data on product container when variant changes (for tracking)
      if (this.isQuickview) {
        const productContainer = document.querySelector('.product');
        if (productContainer && this.currentVariant) {
          productContainer.setAttribute('data-current-variant', JSON.stringify(this.currentVariant));
        }
      }

      setTimeout(() => {
        this.updateRegionStatus(this.preparePriceChangeTextForSROnly());
      }, 250);
    }
  }

  updateRegionStatus(msg, forceEmpty = true) {
    if (!this.statusElem || !msg) return;
    this.statusElem.textContent = msg;
    if (!forceEmpty) return;
    setTimeout(() => {
      this.statusElem.textContent = '';
    }, 500);
  }

  preparePriceChangeTextForSROnly() {
    if (!this.currentVariant) return;

    let text = `Sale Price: ${Shopify.formatMoney(this.currentVariant.price)}`;
    if (this.currentVariant.compare_at_price) {
      text += ` Regular Price: ${Shopify.formatMoney(this.currentVariant.compare_at_price)}`;

      const diff = this.currentVariant.compare_at_price - this.currentVariant.price;
      text += ` You Save: ${Shopify.formatMoney(diff)}`;
    }

    return text;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionLabel() {
    if (!this.currentVariant) return;
    const currentSelected1 = document.querySelector('.current-selected-1');
    const currentSelected2 = document.querySelector('.current-selected-2');
    const currentSelected3 = document.querySelector('.current-selected-3');
    const ozValue = 29.5735;
    const unitConvertArr = this.currentVariant.option1.split('oz');
    const selectedVal = this.currentVariant.option1;
    let selectedValSliced;
    if (this.currentVariant.option1.includes('oz')) {
      selectedValSliced = selectedVal.slice(0, selectedVal.length - 1);
    } else {
      selectedValSliced = selectedVal.slice(0, selectedVal.length);
    }
    if (selectedVal.includes('Tester')) {
      const selectedValArr = selectedVal.split('Tester');
      selectedValSliced = selectedValArr[0].slice(0, selectedValArr[0].length - 2);
      selectedValSliced = selectedValSliced + ' Tester';
    }
    const unitConvertArrValue = Number(unitConvertArr[0]);

    const conversions = {
      0.05: 1.5,
      0.17: 5,
      0.5: 15,
      0.8: 25,
      1.0: 30,
      1.4: 40,
      1.7: 50,
      2.0: 60,
      2.5: 75,
      2.7: 80,
      3.0: 90,
      3.3: 100,
      3.4: 100,
      4.2: 125,
      5.0: 150,
      6.7: 200,
    };
    const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);

    if (currentSelected1) currentSelected1.textContent = `${selectedValSliced}`;
    if (this.currentVariant.option1.includes('oz')) {
      currentSelected1.textContent = `${selectedValSliced} / ${unitValue}ml`;
    } else {
      if (currentSelected1) currentSelected1.textContent = `${selectedValSliced}`;
    }
    if (currentSelected2) currentSelected2.textContent = this.currentVariant.option2;
    if (currentSelected3) currentSelected3.textContent = this.currentVariant.option3;
  }

  updateProductQuantity() {
    if (!this.currentVariant) return;
    const quantityValue = document.querySelector('.quantity__input');
    quantityValue.value = 1;
  }
  toggleQuantityButtonState() {
    document
      .querySelector('.quantity__button[name="plus"]')
      .classList.remove('disableQuantitySelector');
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    // if (!this.currentVariant.featured_media) return;
    document.querySelector('.currentVariantId').dataset.vid = this.currentVariant.id;
    const size = this.currentVariant.option1;
    const media_id = this.currentVariant.featured_media && this.currentVariant.featured_media.id;
    let $mainSlider = null;
    if (window.innerWidth > 1025) {
      $mainSlider = $('.product-photos .product-main-slider');
    } else {
      $mainSlider = $('.mobile-pdp-slider-wrap');
    }
    if (!$mainSlider || $mainSlider.length === 0) return;
    let $slideNode = null;
    if (media_id) {
      $slideNode = $mainSlider.find(`.slick-slide[data-mediaid='${media_id}']`);
    }
    if (!$slideNode || $slideNode.length === 0) {
      $slideNode = $mainSlider.find(`.slick-slide[data-mediaalt='${size}']`);
    }

    if ($slideNode && $slideNode.length) {
      try {
        $mainSlider.slick('slickGoTo', $slideNode.attr('data-slick-index'));
      } catch (err) {}
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // Changes start for 2 day shipping badge
    // Update the variant selector element with new variant data
    const variantSelector = document.querySelector('.ctm_variant_all_listing');
    if (variantSelector && this.currentVariant) {
      variantSelector.setAttribute('data-available', this.currentVariant.available);
      variantSelector.setAttribute(
        'data-allow-express-shipping',
        this.currentVariant.allowExpressShipping
      );
      // Properly handle the brightperlInventory metafield - JSON.stringify if it's an object, otherwise use as is
      const inventoryData = this.currentVariant.brightperlInventory;

      if (inventoryData && typeof inventoryData === 'object') {
        variantSelector.setAttribute('data-brightperl-inventory', JSON.stringify(inventoryData));
      } else {
        variantSelector.setAttribute('data-brightperl-inventory', inventoryData || 'null');
      }
    }

    const variantChangeEvent = new CustomEvent('variant:change', {
      detail: {
        variant: this.currentVariant,
      },
    });
    document.dispatchEvent(variantChangeEvent);
    // Changes end for 2 day shipping badge
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelectorAll('.priceSection');
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const sourcePrice = html.querySelector(`.priceSection`);
        if (sourcePrice && destination.length) {
          destination.forEach((des) => {
            des.innerHTML = sourcePrice.innerHTML;
          });
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const freeShipDestination = this.ProductContainer.querySelector('[data-freeshipnote]');
        const freeShipSource = html.querySelector('[data-freeshipnote]');
        if (freeShipDestination && freeShipSource)
          freeShipDestination.innerHTML = freeShipSource.innerHTML;

        const wishlistBtnDestination = this.ProductContainer.querySelectorAll('.pdp-wishlist-prod');
        const wishlistBtnSource = html.querySelector('.pdp-wishlist-prod');
        if (wishlistBtnDestination.length && wishlistBtnSource) {
          wishlistBtnDestination.forEach(function (destination) {
            destination.innerHTML = wishlistBtnSource.innerHTML;
          });
        }

        _theme.toggleLoading(0);

        const parent = html.getElementById(`ProductInfo-${this.dataset.section}`);
        const variantCont = parent.closest('.product-shop').querySelector('variant-radios');
        const variantSelected = variantCont.firstElementChild.querySelectorAll('input');

        const labelsDestinations = this.ProductContainer.querySelectorAll('[data-label]');
        const labelsSources = html.querySelectorAll('[data-label]');
        if (labelsDestinations.length && labelsSources.length) {
          labelsDestinations.forEach(function (dst, index) {
            dst.innerHTML = labelsSources[index].innerHTML;
          });
        }

        this.syncTagDescriptions(this.ProductContainer, html);

        _theme.Wishlist.init();
        _theme.toggleLoading(0);
      });
  }

  syncTagDescriptions(ProductContainer, html) {
    try {
      const tagDescDestinations = ProductContainer.querySelectorAll(
        '.ctm-product-tags-description'
      );
      const tagDescSources = html.querySelectorAll('.ctm-product-tags-description');
      const tagsContainer = ProductContainer.querySelector(
        '.product__info-container variant-radios'
      );

      // Remove existing if no sources
      if (tagDescSources.length === 0) {
        tagDescDestinations.forEach((el) => el.remove());
        return;
      }

      // Clear existing destinations
      tagDescDestinations.forEach((el) => el.remove());

      // Insert new containers
      tagDescSources.forEach((source) => {
        const container = document.createElement('div');
        container.className = 'ctm-product-tags-description';
        container.innerHTML = source.innerHTML;
        tagsContainer.insertAdjacentElement('afterend', container);
      });
    } catch (error) {
      console.error('Error syncing tag descriptions:', error);
    }
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const checkoutButton = productForm.querySelector('[name="custom_checkout"]');
    const checkoutButtonText = productForm.querySelector('[name="custom_checkout"] > span');
    const quantityButtons = document.querySelector('.product-shop .product-form__quantity');
    if (!addButton) return;

    if (!this.currentVariant.available) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = 'Out of Stock';
      if (checkoutButton) {
        checkoutButton.setAttribute('disabled', 'disabled');
        checkoutButtonText.textContent = 'Buy It Now';
      }
      quantityButtons.querySelector('[name="plus"]').setAttribute('disabled', 'disabled');
      quantityButtons.querySelector('[name="minus"]').setAttribute('disabled', 'disabled');

      if (_theme.isIpad) {
        productForm.closest('.product-form-div').classList.add('noStock');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (checkoutButton) {
        checkoutButton.removeAttribute('disabled');
        checkoutButtonText.textContent = 'Buy It Now';
      }
      quantityButtons.querySelector('[name="plus"]').removeAttribute('disabled');
      quantityButtons.querySelector('[name="minus"]').removeAttribute('disabled');

      if (_theme.isIpad) {
        productForm.closest('.product-form-div').classList.remove('noStock');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const bisForm = document.querySelector('[data-backinstockform]');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (bisForm) bisForm.classList.add('hidden');
  }

  getVariantData() {
    // Get the original variants data (this has all the standard Shopify properties)
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    // Try to get metafield data from shipping_variants_data and merge it
    const shippingVariantsScript = document.getElementById('shipping_variants_data');
    if (shippingVariantsScript) {
      try {
        const shippingData = JSON.parse(shippingVariantsScript.textContent);

        // Merge metafield data into the original variant data
        this.variantData.forEach((variant, index) => {
          if (shippingData[index] && shippingData[index].brightperl_inventory) {
            variant.brightperlInventory = shippingData[index].brightperl_inventory;
          }
          if (shippingData[index] && shippingData[index].allow_express_shipping) {
            variant.allowExpressShipping = shippingData[index].allow_express_shipping;
          }
        });
      } catch (e) {
        console.warn('Error merging metafield data:', e);
      }
    }

    return this.variantData;
  }

  updateKlarnaWidget() {
    const klarna = document.querySelector('.product-shop klarna-placement');
    if (!klarna || !this.currentVariant) return;
    klarna.setAttribute('data-purchase-amount', this.currentVariant.price);
    _theme.Helpers.refreshKlarna();
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
